import * as React from "react";
import { forwardRef } from "react";
const AccountCreateIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "data-category": "other",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 12c-1.5646 0-2.83698-1.2664-2.83698-2.82354 0-1.55717 1.27238-2.82353 2.83698-2.82353s2.837 1.26636 2.837 2.82353C14.837 10.7336 13.5646 12 12 12m2.6653.4751c1.1256-.9015 1.7816-2.3591 1.5405-3.95511-.2801-1.85153-1.8277-3.33317-3.6959-3.54917-2.57806-.29859-4.76537 1.69905-4.76537 4.20564 0 1.33414.6213 2.52284 1.59013 3.29864-2.38022.8901-4.11787 2.9802-4.39022 5.8009-.03972.4172.28724.7828.70853.7828.36101 0 .66882-.271.70074-.6289.2844-3.1504 2.70789-5.0181 5.64629-5.0181s5.3619 1.8677 5.6463 5.0181c.0319.3579.3397.6289.7007.6289.4213 0 .7483-.3656.7085-.7828-.2723-2.8207-2.01-4.9108-4.3902-5.8009M17.8649 0c.3582 0 .6486.29041.6486.648649V2.59461h1.946c.3582 0 .6486.29041.6486.64865s-.2904.64865-.6486.64865h-1.946v1.94593c0 .35824-.2904.64865-.6486.64865-.3583 0-.6487-.29041-.6487-.64865V3.89191h-1.9459c-.3583 0-.6487-.29041-.6487-.64865s.2904-.64865.6487-.64865h1.9459V.648649C17.2162.29041 17.5066 0 17.8649 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 1.33906C6.11212 1.33906 1.33906 6.11212 1.33906 12c0 5.8879 4.77306 10.6609 10.66094 10.6609 5.8879 0 10.6609-4.773 10.6609-10.6609 0-2.28311-.7169-4.39677-1.9379-6.13072l1.0948-.77099C23.1926 7.05055 24 9.43198 24 12c0 6.6274-5.3726 12-12 12-6.62742 0-12-5.3726-12-12C0 5.37258 5.37258 0 12 0c.5544 0 1.1004.0376456 1.6355.110604l-.1809 1.326776c-.4753-.0648-.9608-.09832-1.4546-.09832",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(AccountCreateIcon);
ForwardRef.category = "other";
export { ForwardRef as AccountCreateIcon };